import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const OrbitalAnimation = ({
  className
}: {
  className?: string;
}) => <div className={className} data-id="element-161">
    <svg viewBox="0 0 400 400" className="w-full h-full animate-[spin_120s_linear_infinite]" data-id="element-162">
      {/* Central Node with pulse animation */}
      <circle cx="200" cy="200" r="10" fill="#063B63" className="animate-[pulse_4s_ease-in-out_infinite]" data-id="element-163" />
      <circle cx="200" cy="200" r="50" fill="none" stroke="#0A5FA0" strokeWidth="1" strokeDasharray="4 4" opacity="0.35" data-id="element-164" />

      {/* Orbit 1 */}
      <circle cx="200" cy="200" r="100" fill="none" stroke="#0A5FA0" strokeWidth="1.5" opacity="0.3" data-id="element-165" />
      <circle cx="129" cy="129" r="6" fill="#0A5FA0" data-id="element-166" />
      <circle cx="271" cy="271" r="8" fill="#37A9F5" data-id="element-167" />
      <circle cx="100" cy="200" r="5" fill="#8C929A" data-id="element-168" />

      {/* Orbit 2 */}
      <circle cx="200" cy="200" r="160" fill="none" stroke="#0A5FA0" strokeWidth="1.5" opacity="0.25" data-id="element-169" />
      <circle cx="87" cy="87" r="7" fill="#063B63" data-id="element-170" />
      <circle cx="313" cy="313" r="6" fill="#8C929A" data-id="element-171" />
      <circle cx="360" cy="200" r="9" fill="#0A5FA0" data-id="element-172" />
      <circle cx="40" cy="200" r="5" fill="#37A9F5" data-id="element-173" />

      {/* Connecting Lines - blue */}
      <line x1="200" y1="200" x2="129" y2="129" stroke="#0A5FA0" strokeWidth="1" opacity="0.35" data-id="element-174" />
      <line x1="200" y1="200" x2="271" y2="271" stroke="#0A5FA0" strokeWidth="1" opacity="0.35" data-id="element-175" />
      <line x1="129" y1="129" x2="87" y2="87" stroke="#0A5FA0" strokeWidth="1" opacity="0.25" data-id="element-176" />
      <line x1="271" y1="271" x2="313" y2="313" stroke="#0A5FA0" strokeWidth="1" opacity="0.25" data-id="element-177" />
      <line x1="200" y1="200" x2="360" y2="200" stroke="#0A5FA0" strokeWidth="1" opacity="0.3" data-id="element-178" />
      <line x1="100" y1="200" x2="40" y2="200" stroke="#0A5FA0" strokeWidth="1" opacity="0.3" data-id="element-179" />

      {/* Cross Connections */}
      <line x1="129" y1="129" x2="100" y2="200" stroke="#0A5FA0" strokeWidth="0.75" opacity="0.2" data-id="element-180" />
      <line x1="271" y1="271" x2="360" y2="200" stroke="#0A5FA0" strokeWidth="0.75" opacity="0.2" data-id="element-181" />
      <line x1="87" y1="87" x2="40" y2="200" stroke="#0A5FA0" strokeWidth="0.75" opacity="0.15" data-id="element-182" />
    </svg>
  </div>;
export function QuienesSomos() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.15
  });
  return <section id="quienes-somos" className="py-10 md:py-14 bg-[#F6F7F9]" data-id="element-183">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-184">
        {/* Section Header */}
        <div className="mb-8" data-id="element-185">
          <div className="h-px w-16 bg-silver-main mb-6" data-id="element-186"></div>
          <h2 className="font-heading text-4xl md:text-5xl text-petrol-dark font-light leading-tight mb-4" data-id="element-187">
            Quiénes Somos
          </h2>
          <p className="font-body text-base text-gray-500 leading-relaxed max-w-2xl" data-id="element-188">
            Un nuevo estándar en consultoría de incidencia y políticas públicas.
          </p>
        </div>

        {/* Two-Column Layout: Orbital + Text */}
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 scroll-animate ${isVisible ? 'is-visible' : ''}`} data-id="element-189">
          {/* LEFT: Orbital Animation */}
          <div className="lg:col-span-5 flex items-center justify-center lg:justify-start" data-id="element-190">
            {/* Mobile: centered above text */}
            <OrbitalAnimation className="lg:hidden w-56 h-56 opacity-35" data-id="element-191" />
            {/* Desktop: larger, more visible */}
            <OrbitalAnimation className="hidden lg:block w-80 h-80 xl:w-96 xl:h-96 opacity-45" data-id="element-192" />
          </div>

          {/* RIGHT: Text Content */}
          <div className="lg:col-span-7 font-body text-base md:text-lg text-gray-600 leading-[1.85] space-y-5" data-id="element-193">
            <p className="italic text-gray-500" data-id="element-194">
              "La mayoría cree que el sector público y el privado hablan idiomas
              distintos. Nosotros creemos que solo necesitan un mejor diseño."
            </p>

            <p data-id="element-195">
              Estamos fundando un nuevo estándar en consultoría de incidencia y
              políticas públicas. Nacemos de la experiencia acumulada de más de
              veinte años de nuestros socios en la primera línea del Estado y la
              regulación.
            </p>

            {/* Mission Block - Highlighted */}
            <div className="py-6 my-3" data-id="element-196">
              <div className="h-px w-12 bg-petrol-medium mb-5" data-id="element-197"></div>
              <p className="font-heading text-2xl md:text-3xl font-bold text-petrol-dark leading-snug" data-id="element-198">
                Nuestra misión es simple: Redefinir la gobernanza.
              </p>
              <div className="h-px w-12 bg-petrol-medium mt-5" data-id="element-199"></div>
            </div>

            <p data-id="element-200">
              En un mundo de transformación acelerada, el sector público no
              puede ser un freno y el sector privado no puede actuar a ciegas.
              Trabajamos en esa intersección. Tomamos la complejidad de la
              normativa y la fragmentación de la política para transformarlas en
              claridad estratégica.
            </p>

            <p data-id="element-201">
              No entregamos informes complejos, entregamos hojas de ruta.
              Despejamos la incertidumbre para crear escenarios de impacto real
              y planes de acción que respeten la coherencia institucional.
            </p>
          </div>
        </div>

        {/* Centered Institutional Quote Block */}
        <div className="py-8 mt-6" data-id="element-202">
          <div className="max-w-3xl mx-auto text-center relative" data-id="element-203">
            {/* Decorative line above */}
            <div className="h-px w-16 bg-silver-main mx-auto mb-8" data-id="element-204"></div>

            {/* Decorative quotation mark */}
            <span className="absolute -top-4 left-1/2 -translate-x-1/2 font-heading text-7xl md:text-8xl text-petrol-dark/10 leading-none select-none pointer-events-none" data-id="element-205">
              "
            </span>

            <p className="font-heading italic text-xl md:text-2xl lg:text-3xl text-petrol-dark leading-snug mb-6 relative z-10" data-id="element-206">
              Donde otros ven ruido político, nosotros vemos una estructura que
              necesita orden. Donde otros improvisan, nosotros aplicamos la
              disciplina de la experiencia.
            </p>

            <p className="font-body font-semibold text-base md:text-lg text-petrol-dark" data-id="element-207">
              Estamos aquí para aportar equilibrio. Para dar dirección. Para
              hacer que la gobernanza funcione.
            </p>

            {/* Decorative line below */}
            <div className="h-px w-16 bg-silver-main mx-auto mt-8" data-id="element-208"></div>
          </div>
        </div>

        {/* Equipo Block */}
        <div className="pt-8 mt-2" data-id="element-209">
          <div className="h-px w-full bg-silver-main/30 mb-8" data-id="element-210"></div>
          <div className="max-w-2xl mx-auto" data-id="element-211">
            <h3 className="font-body text-xs font-semibold uppercase tracking-widest text-silver-dark mb-6 text-center" data-id="element-212">
              Equipo
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-4" data-id="element-213">
              <p className="font-body text-base md:text-lg text-petrol-dark text-center sm:text-right" data-id="element-214">
                Jorge Triaca
              </p>
              <p className="font-body text-base md:text-lg text-petrol-dark text-center sm:text-left" data-id="element-215">
                Santiago Bozzo
              </p>
              <p className="font-body text-base md:text-lg text-petrol-dark text-center sm:text-right" data-id="element-216">
                Mariana Hortal Sueldo
              </p>
              <p className="font-body text-base md:text-lg text-petrol-dark text-center sm:text-left" data-id="element-217">
                Maria Breggia
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}